module.exports = __webpack_public_path__ + "static/media/homework.5b207c56.png";